const { createSlice } = require("@reduxjs/toolkit");

const initialState = false;

const portLoginSlice = createSlice({
    name: "portLogin",
    initialState,
    reducers: {
        setPortLogin: (state, action) => {
            return action.payload;
        },
    },
});

export const { setPortLogin } = portLoginSlice.actions;
export default portLoginSlice.reducer;